import { useMemo } from "react";
import { useBuilderStore } from "@circle-react-shared/BuilderUI";
import {
  createDebouncedRecalculatePositions,
  createRecalculatePositions,
} from "../Helpers/createRecalculatePositions";

export const useDropZoneRecalculation = () => {
  const setDropZonePositions = useBuilderStore(
    state => state.setDropZonePositions,
  );

  const recalculatePositions = useMemo(
    () => createRecalculatePositions(setDropZonePositions),
    [setDropZonePositions],
  );

  const debouncedRecalculatePositions = useMemo(
    () => createDebouncedRecalculatePositions(setDropZonePositions),
    [setDropZonePositions],
  );

  return {
    recalculatePositions,
    debouncedRecalculatePositions,
  };
};
